import { useCallback, useEffect, useState } from 'react';
import { TOption } from '@src/types';
import { getProducts } from '@src/services/products.ts';

export const useProducts = () => {
  const [products, setProducts] = useState<TOption[]>([]);

  const fetchProductOptions = useCallback(async () => {
    const res = await getProducts();
    const options = res.data.map((item) => ({
      label: item.title,
      value: item.id?.toString() || '',
    }));

    setProducts(options as unknown as TOption[]);
  }, []);

  useEffect(() => {
    fetchProductOptions().then();
  }, [fetchProductOptions]);

  return { products, refresh: fetchProductOptions };
};
